var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.003,
    height: 60,
    viewBox: "0 0 60.003 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M14742.8,2102.038l1.7,8.428-1.7,5.282,1.7,8.5,4,6.345,7.494,4.119h7.917l5.464-1.918,2.854-3.623,3.717-4.924,1.255-5.993-1.255-7.789-3.717-4.107-2.854-2.611-5.464-2.793h-4.882l-5.06,1.083-2.159.917-9.01-2Z",
    transform: "translate(-14716 -2074)",
    fill: "#d6fffa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12158",
    "data-name": "Path 12158",
    d: "M14751.7,2112.874l.413-2.766,1.963-.534,5.913,5.569,5.794-5.569,2.331.968v2.333l-5.242,5.137,5.242,5.38v2.738h-3.341l-4.784-5.129-5.913,5.595-2.376-.867v-2.336l5.2-5.38Z",
    transform: "translate(-14716 -2074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12118",
    "data-name": "Path 12118",
    d: "M13,20h5a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.005)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12119",
    "data-name": "Path 12119",
    d: "M13,24h9a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.006)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12120",
    "data-name": "Path 12120",
    d: "M13,28H23a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.007)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12121",
    "data-name": "Path 12121",
    d: "M13,32H23a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.009)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12122",
    "data-name": "Path 12122",
    d: "M13,36H24a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.01)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12123",
    "data-name": "Path 12123",
    d: "M13,40H24a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.011)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12124",
    "data-name": "Path 12124",
    d: "M13,44H23a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.012)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12125",
    "data-name": "Path 12125",
    d: "M13,48H23a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.014)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12126",
    "data-name": "Path 12126",
    d: "M22,20H41a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z",
    transform: "translate(0 0.005)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12127",
    "data-name": "Path 12127",
    d: "M41,22H26a1,1,0,0,0,0,2H41a1,1,0,0,0,0-2Z",
    transform: "translate(0 0.006)",
    fill: "#5dadae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12128",
    "data-name": "Path 12128",
    d: "M52.485,48.243,48.243,44l4.243-4.243a3,3,0,1,0-4.243-4.242L44,39.757l-4.243-4.243a3,3,0,1,0-4.242,4.243L39.757,44l-4.243,4.243a3,3,0,1,0,4.243,4.242L44,48.243l4.243,4.243a3,3,0,1,0,4.243-4.243Zm-1.414,2.828a1,1,0,0,1-1.414,0l-4.95-4.949a1,1,0,0,0-1.414,0l-4.95,4.949a1,1,0,1,1-1.414-1.414l4.949-4.95a1,1,0,0,0,0-1.414l-4.949-4.95a1,1,0,1,1,1.414-1.414l4.95,4.949a1,1,0,0,0,1.414,0l4.95-4.949a1,1,0,1,1,1.414,1.414l-4.949,4.95a1,1,0,0,0,0,1.414l4.949,4.95A1,1,0,0,1,51.071,51.071Z",
    transform: "translate(0 0.018)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12117",
    "data-name": "Path 12117",
    d: "M46,26.125V15a1.009,1.009,0,0,0-.293-.707l-12-12A1.009,1.009,0,0,0,33,2H11A3,3,0,0,0,8,5V6H5A3,3,0,0,0,2,9V57.016a3,3,0,0,0,3,3H33a3,3,0,0,0,1.751-.587A17.991,17.991,0,1,0,46,26.125ZM34,5.415,42.586,14H35a1,1,0,0,1-1-1ZM10,5a1,1,0,0,1,1-1H32v9a3,3,0,0,0,3,3h9v10a17.783,17.783,0,0,0-7.587,1.7l-9.234-1.679a1,1,0,0,0-1.165,1.149l1.578,9.473A17.826,17.826,0,0,0,27.9,52.015H11a1,1,0,0,1-1-1ZM5,58.017a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8H8V51.015a3,3,0,0,0,3,3H29.044a18.144,18.144,0,0,0,3.667,4Zm39,2a16.021,16.021,0,0,1-16-16,15.844,15.844,0,0,1,1.534-6.8,1,1,0,0,0,.081-.59L28.22,28.246l8.153,1.482a1,1,0,0,0,.618-.085A15.822,15.822,0,0,1,44,28.008a16,16,0,0,1,0,32.01Z",
    transform: "translate(0 0)",
    fill: "#5dadae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.476149ba22d01557132cee6aec9c5645.svg";
export { ForwardRef as ReactComponent };